export default {
    general: {
        newCalculation: 'Fazer um novo cálculo',
        loadingButton: 'Calculando...',
        importantTitle: 'Importante: ',
        importantInfo: 'Informe o nome completo corretamente para um cálculo preciso.',
        resultButton: 'Veja sua interpretação grátis!',
        errors: {
            nameLength: 'Mínimo de 3 caracteres',
            request: 'Não conseguimos calcular agora. Tente novamente em instantes.'
        }
    },
    types: {
        name: {
            title: 'Calcule a Numerologia do seu nome!',
            subtitle: 'Descubra gratuitamente seu Número de Expressão e conheça sua verdadeira essência!',
            label: 'Digite seu nome completo:',
            placeholder: 'Seu nome completo',
            button: 'Calcular meu número',
            result: {
                title: 'Calculadora de Numerologia do Nome',
                label: 'Seu número de expressão é: ',
                description: 'Você tem um número poderoso! Nossa IA revela seu verdadeiro significado e como usá-lo a seu favor.'
            },
            question: 'A energia numerológica do meu nome é regida pelo número {number}. Como isso influencia minhas características e destino?'
        },
        love: {
            title: 'Descubra a numerologia do nome do seu amor!',
            subtitle: 'Descubra gratuitamente o Número de Expressão do seu amor e entenda sua verdadeira essência!',
            label: 'Digite o nome completo da pessoa amada:',
            placeholder: 'Nome do seu amor',
            button: 'Calcular o número',
            result: {
                title: 'Calculadora de Numerologia do Nome',
                label: 'O Número de Expressão do seu amor é: ',
                description: 'Esse número revela a essência da pessoa amada! Nossa IA mostra seu significado e como ele impacta a relação de vocês.'
            },
            question: 'O que a energia do número {number} na numerologia do amor indica?'
        },
        business: {
            title: 'Descubra a numerologia do nome da sua empresa!',
            subtitle: 'Entenda a energia por trás do nome da sua empresa e desbloqueie seu verdadeiro potencial!',
            label: 'Digite o nome completo da sua empresa:',
            placeholder: 'Nome da sua empresa',
            button: 'Calcular o número',
            result: {
                title: 'Calculadora de Numerologia Empresarial',
                label: 'O Número de Expressão da sua empresa é: ',
                description: 'Esse número revela o potencial e a identidade da sua marca! Nossa IA explica seu verdadeiro significado e como usá-lo a seu favor.'
            },
            question: 'O número {number} na numerologia empresarial indica quais oportunidades e desafios no mercado?'
        }
    }
};
